import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("vm_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export default api;

export const CATEGORIES = ["Antipasti", "Primi", "Secondi", "Dessert", "Bevande"];
export const ALLERGENS = ["Glutine", "Lattosio", "Uova", "Frutta a Guscio", "Pesce", "Crostacei", "Soia", "Sedano", "Senape"];
